import { QcBizResponder } from "@/modules/staff/objects/QcBizResponder";
import { InquiryService } from "@/framework/api/Staff/ChatService/InquiryService";
import { err, ok, Result } from "neverthrow";
import GraphqlApiError from "@/framework/network/gql/GraphqlApiError";

export const createQcBizResponder = (): QcBizResponder => ({
  id: 0,
  name: "",
  tenant_id: 0,
});

export const getBizResponder = async (): Promise<Result<QcBizResponder, GraphqlApiError>> => {
  const res = await new InquiryService().getResponder();
  if (res.isErr()) return err(res.error);
  else if (res.isOk() && res.value.responder) {
    return res.value.responder.id ? ok(res.value.responder as QcBizResponder) : ok(createQcBizResponder());
  } else {
    return ok(createQcBizResponder());
  }
};
